import React, { useEffect, useState } from 'react';
import { Skeleton } from '@mui/material';

const UrlShortener: React.FC<{ url: string }> = ({ url }) => {
  const [shortenedUrl, setShortenedUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

  async function shortenUrl(url: string): Promise<string> {
    const response = await fetch(`https://tinyurl.com/api-create.php?url=${encodeURIComponent(url)}`);
    const shortUrl = await response.text(); // The TinyURL API returns the shortened URL as plain text
    return shortUrl;
  }

  const handleShortenUrl = async () => {
    try {
      const shortUrl = await shortenUrl(url);
      setShortenedUrl(shortUrl);
    } catch (error) {
      setShortenedUrl(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleShortenUrl();
  }, [url]);

  const newUrl = !shortenedUrl || shortenedUrl === 'Error' ? url : shortenedUrl;

  return (
    <>
      {loading && <Skeleton width={100} height={22} data-testid="url-shortener-skeleton" />}
      {!loading && (
        <a target="_blank" rel="noreferrer" href={newUrl}>
          {newUrl}
        </a>
      )}
    </>
  );
};

export default UrlShortener;
